<input type="date" min="2010-01-01" [max]="dateToday" [(ngModel)]="answer" (change)="answerQuestion(options,answer);">
